'use strict';

angular.module('supervisorAuthorizingUserRequestControllers')

.controller('MainSupervisorAuthorizingController', ['$scope', '$translate', 'topBar', 'userRequestsToAuthorize', function ($scope, $translate, topBar, userRequestsToAuthorize) {

    $scope.userRequestsToAuthorize = userRequestsToAuthorize;

    $translate('iam.supervisor.authorizingUserRequest.pageTitle').then(function(translation) {
        topBar.setTitleAndIcon(translation, 'fa fa-gavel');
    });

    // Display actions
    $scope.displayActions = false;

    $scope.showOrHideActions = function ($event) {
        $scope.displayActions = !$scope.displayActions;
        $event.stopPropagation();
    }

}]);
